import { c as _c } from "react/compiler-runtime";
import React, { useState } from "react";
import style from "./DatePickerInput.module.scss";
import { DatePicker } from "./DatePicker";
import { Calendar } from "react-feather";
export type DatePickerInputConfiguration = {
  last_day_of_month_label: string;
  payment_last_date_of_month_option: boolean;
  payment_date_format_template: string;
  payment_date_last_day_of_month_template: string;
};
export const DatePickerInput: React.FC<{
  selected?: number;
  onChange: (selected: number) => void;
  configuration?: DatePickerInputConfiguration;
  disabled?: boolean;
}> = t0 => {
  const $ = _c(28);
  const {
    selected,
    configuration,
    onChange,
    disabled
  } = t0;
  const [pickerOpen, setPickerOpen] = useState(false);
  if (!configuration) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <span>Missing date input config</span>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let t1;
  if ($[1] !== configuration || $[2] !== selected) {
    t1 = getTextValue(selected, configuration);
    $[1] = configuration;
    $[2] = selected;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const textValue = t1;
  const t2 = `${style["datepicker-input-wrapper"]} ${disabled ? style.disabled : ""}`;
  const t3 = pickerOpen ? undefined : "none";
  let t4;
  if ($[4] !== t3) {
    t4 = {
      display: t3
    };
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== onChange) {
    t5 = selected_0 => {
      onChange(selected_0);
      setPickerOpen(false);
    };
    $[6] = onChange;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => setPickerOpen(false);
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== configuration.last_day_of_month_label || $[10] !== configuration.payment_last_date_of_month_option || $[11] !== selected || $[12] !== t5) {
    t7 = <DatePicker selected={selected} onChange={t5} onClickOutside={t6} lastDayOfMonthOption={configuration.payment_last_date_of_month_option} lastDayOfMonthLabel={configuration.last_day_of_month_label} />;
    $[9] = configuration.last_day_of_month_label;
    $[10] = configuration.payment_last_date_of_month_option;
    $[11] = selected;
    $[12] = t5;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t4 || $[15] !== t7) {
    t8 = <div className={style["datepicker-container"]} style={t4}>{t7}</div>;
    $[14] = t4;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== disabled) {
    t9 = () => !disabled && setPickerOpen(true);
    $[17] = disabled;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== disabled || $[20] !== t9 || $[21] !== textValue) {
    t10 = <input readOnly={true} disabled={disabled} type="text" value={textValue} onClick={t9} data-cy="date-picker-input" />;
    $[19] = disabled;
    $[20] = t9;
    $[21] = textValue;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Calendar />;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t10 || $[25] !== t2 || $[26] !== t8) {
    t12 = <div className={t2}>{t8}{t10}{t11}</div>;
    $[24] = t10;
    $[25] = t2;
    $[26] = t8;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  return t12;
};
const getTextValue = (selected: number | undefined, configuration: DatePickerInputConfiguration) => {
  if (typeof selected !== "undefined") if (selected === 0) {
    if (configuration.payment_last_date_of_month_option) {
      return configuration.payment_date_last_day_of_month_template;
    } else {
      return "Invalid date";
    }
  } else {
    return configuration.payment_date_format_template.replace("{{date}}", selected.toString());
  }
  return "";
};